
import useAddToMyCollectionsModal from '@/components/AddToMyCollectionsModal/AddToMyCollectionsModal';
import BaseButton from '@/components/Common/BaseButton/BaseButton.vue';
import BaseSelect from '@/components/Common/BaseSelect/BaseSelect.vue';
import ModalWindow from '@/components/Common/ModalWindow/ModalWindow.vue';
import TextField from '@/components/Common/TextField/TextField.vue';
import CollectionsSelectorMobile from './CollectionsSelectorMobile/CollectionsSelectorMobile.vue';
import FormSelectorMobile from './FormSelectorMobile/FormSelectorMobile.vue';

export default {
  components: {
    BaseButton,
    BaseSelect,
    CollectionsSelectorMobile,
    FormSelectorMobile,
    ModalWindow,
    TextField,
  },
  props: {
    isOpen: {
      required: false,
      type: Boolean,
    },
    template: {
      required: false,
      type: Object,
    },
  },
  setup(props) {
    return useAddToMyCollectionsModal(props);
  },
};
